import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {InstutionRole} from './instution-role.model';
import * as InstutionRoleActions from './instution-role.actions';

export const instutionRolesFeatureKey = 'instutionRoles';

export interface State extends EntityState<InstutionRole> {
  // additional entities state properties
}

export const adapter: EntityAdapter<InstutionRole> = createEntityAdapter<InstutionRole>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(InstutionRoleActions.addInstutionRole,
    (state, action) => adapter.addOne(action.instutionRole, state)
  ),
  on(InstutionRoleActions.upsertInstutionRole,
    (state, action) => adapter.upsertOne(action.instutionRole, state)
  ),
  on(InstutionRoleActions.addInstutionRoles,
    (state, action) => adapter.addMany(action.instutionRoles, state)
  ),
  on(InstutionRoleActions.upsertInstutionRoles,
    (state, action) => adapter.upsertMany(action.instutionRoles, state)
  ),
  on(InstutionRoleActions.updateInstutionRole,
    (state, action) => adapter.updateOne(action.instutionRole, state)
  ),
  on(InstutionRoleActions.updateInstutionRoles,
    (state, action) => adapter.updateMany(action.instutionRoles, state)
  ),
  on(InstutionRoleActions.deleteInstutionRole,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(InstutionRoleActions.deleteInstutionRoles,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(InstutionRoleActions.loadInstutionRoles,
    (state, action) => adapter.setAll(action.instutionRoles, state)
  ),
  on(InstutionRoleActions.clearInstutionRoles,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
